import { dsEnums } from '@vectronic/openApi-admin';

export type TimeType = 'permanent' | 'temporary';
export type AdditionalConditionTriggerType =
  | 'proximity'
  | 'no proximity'
  | 'inside virtual fence'
  | 'outside virtual fence'
  | 'vit implanted'
  | 'vit expelled'
  | 'vit contact'
  | 'vit no contact';
export type RepeatIntervalType = 'daily' | 'weekly' | 'advanced';
export type VitTriggerType = 0 | 1 | 2 | 3;

export const MIN_DATE = '2000-01-01';
export const MAX_DATE = '2100-01-01';
export const TIME_TYPE_OPTIONS: {
  value: TimeType;
  label: string;
}[] = [
  {
    value: 'permanent',
    label: 'Permanent',
  },
  {
    value: 'temporary',
    label: 'Temporary',
  },
];

export const ADDITIONAL_CONDITION_TRIGGER_OPTIONS: {
  value: AdditionalConditionTriggerType;
  label: string;
}[] = [
  {
    value: 'proximity',
    label: 'Proximity',
  },
  {
    value: 'no proximity',
    label: 'No Proximity',
  },
  {
    value: 'inside virtual fence',
    label: 'Inside Virtual Fence',
  },
  {
    value: 'outside virtual fence',
    label: 'Outside Virtual Fence',
  },
  {
    value: 'vit implanted',
    label: 'VIT Implanted',
  },
  {
    value: 'vit expelled',
    label: 'VIT Expelled',
  },
  {
    value: 'vit contact',
    label: 'VIT Contact',
  },
  {
    value: 'vit no contact',
    label: 'VIT No Contact',
  },
];
export const MODE_OPTIONS: {
  value: dsEnums.CameraScheduleRuleType;
  label: string;
}[] = [
  {
    value: 'VIDEO',
    label: 'Video',
  },
  {
    value: 'PICTURE',
    label: 'Photo',
  },
];
export const TRIGGER_OPTIONS = (hasHighActivityCameraTrigger: boolean) => {
  const result: {
    value: dsEnums.CameraScheduleRuleMainTrigger;
    label: string;
  }[] = [
    {
      value: 'GPS',
      label: 'GPS',
    },
    {
      value: 'TIMER',
      label: 'Time',
    },
    {
      value: 'VIT',
      label: 'VIT',
    },
    {
      value: 'PROXIMITY_PRELIMANARY',
      label: 'Proximity',
    },
  ];
  if (hasHighActivityCameraTrigger) {
    result.push({
      value: 'HIGH_ACTIVITY',
      label: 'High Activity (Beta)',
    });
  }
  return result;
};
export const REPEAT_INTERVAL_OPTIONS: {
  value: RepeatIntervalType;
  label: string;
}[] = [
  {
    value: 'daily',
    label: 'Daily',
  },
  {
    value: 'weekly',
    label: 'Weekly',
  },
  {
    value: 'advanced',
    label: 'Custom',
  },
];

export const VIT_TRIGGER_OPTIONS: {
  value: VitTriggerType;
  label: string;
}[] = [
  { label: 'Expelled Trigger', value: 1 },
  { label: 'No Contact Trigger', value: 2 },
  { label: 'Exp. & No Contact Trigger', value: 3 },
];
